export interface FractionState {
    isLocalRaspberryConnected: boolean
    isRemotePrinterConnected: boolean
    scaleWeight: ScaleWeight
    fractionTag: FractionTag | undefined
}

export enum GenericApiErrors {
    Failed
}

export interface FinishFraction {
    userId?: string
    expirationDate?: Date
}

export interface Batch {
    arquivo: string
    cod_produto: string
    data_inclusao: Date
    data_validade: Date
    descricao: string
    id_fornecedor: number
    id_lote: number
    nome_fornecedor: string
    quantidade_rejeitada: number
    quantidade_total: number
    quantidade_util: number
    status_fracionamento: string
    unidade_medida: string
    unidade_medida_abreviatura: string
    is_kg: boolean
    fractioning_tag: boolean
}

export interface FractionItem {
    actions: JSX.Element
    batchFractionId: number
    measureUnit: string
    qty: number
    qtyElement: JSX.Element
    styleCell: React.CSSProperties
}

export interface TouchedValues {
    fracao?: number
    userId: string
    product?: string
    provider?: string
    expirationDate: string
    qntLot?: number
}

export interface BatchFraction {
    id_lotefracao: number
    quantidade: number
    data_inclusao: Date
}

export enum FractionFieldStateEnum {
    DEFAULT = 0,
    BELOW = 1,
    WITHIN = 2,
    ABOVE = 3,
}

export interface FractionFieldState {
    color: string
    message: string
    icon: JSX.Element
}

export interface FractionTableHeader {
    name: string
    label: string
}

export interface GetScaleWeightPayload {
    onSuccess: (weight: number | undefined) => void
}

export interface ScaleWeight {
    weight?: number
}

export interface FractionTagFields {
    fieldName: string
    positionX: number
    positionY: number
    fieldType: string
}

export interface FractionTag {
    tagName: string
    fields: FractionTagFields[]
}

export interface PrintFractionTagPayload {
    productDescription: string
    productCode: string
    productBarcode: string
    batchId: string
    fractionInclusionDate: string
    weight: string
}

export interface PauseFractioningPayload {
    idBatch: number
    badge: string
    onSuccess: () => void
    onError: (message: string) => void
}
